// extracted by mini-css-extract-plugin
export default {"wrapper":"ItemList_wrapper__qY-e8","item":"ItemList_item__LXjdb","label":"ItemList_label__mHaCb"};